export default __webpack_public_path__ + "static/media/about-team-tom-freeman.82281050.png";